import React from 'react';
import { connect } from 'react-redux';
import CampaignBannerList from './CampaignBannerList';
function FeaturedCampaignBanner({ campaigns }) {
    return React.createElement(CampaignBannerList, { campaigns: campaigns });
}
function mapStateToProps({ campaign }) {
    const featuredCampaigns = getFeaturedCampaigns(campaign.campaigns);
    return {
        campaigns: featuredCampaigns,
    };
}
function getFeaturedCampaigns(campaigns) {
    return campaigns.filter((c) => c.featured);
}
export default connect(mapStateToProps)(FeaturedCampaignBanner);
